module.exports = __webpack_public_path__ + "img/intro.331db581.png";